<template>
  <div>
    <!-- 奖品预览 -->
    <prizeList :activityId="rowData.id"/>
    <div class="award-title mb16">中奖记录明细</div>
    <jd-form
      class="mb16"
      ref="inputFormRef"
      :form-info="formSchema"
      @search="searchReward"/>
    <div class="flex-between mb12">
      <div>
        <jd-button
          @click="addCrowd"
          type="blueLine"
          :disabled="!awardTable.length"
          >按查询结果生成人群</jd-button>
        <jd-button
          @click="handleMark(2, {})"
          v-preventReClick
          :disabled="!awardTable.length"
          >批量标记发放</jd-button>
          <jd-button
            @click="handleSendPrize"
            >补发奖品</jd-button
          >
      </div>
      <jd-button
        type="text"
        @click="exportFn"
        v-preventReClick
        :disabled="!awardTable.length"
        >导出</jd-button>
    </div>
    <div class="mb12">总计中奖人数：{{allWinPeoples}}人（去重）</div>
    <div class="new-table-box">
      <jd-table
        :loading="tableLoading"
        :tableData="awardTable"
        :pageInfo="{
          pageSize: formList.size,
          total: formList.total,
          pageNum: formList.current
        }"
        :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
        :cell-style="{ 'text-align': 'left' }"
        style="width: 100%;"
        @selection-change="handleSelectionChange"
        @handlePage="handleSizeAwardAll"
        ref="awardTableRef"
      >
        <el-table-column type="selection" width="55" :selectable="limitSelect"></el-table-column>
        <el-table-column prop="chaosPin" label="用户pin（加密）"  width="150">
        </el-table-column>
        <el-table-column prop="memberNick" label="用户昵称" width="160">
        </el-table-column>
        <el-table-column prop="id" label="中奖ID" width="170">
        </el-table-column>
        <el-table-column prop="memberLevel" label="会员等级">
          <template slot-scope="scope">
            <span>{{ levelMap[scope.row.memberLevel] || '' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="sellerLinkName" label="投放渠道"></el-table-column>
        <el-table-column label="奖品类型">
          <template slot-scope="scope">
            <span v-if="scope.row.prizeType == 1">优惠券</span>
            <span v-if="scope.row.prizeType == 2">京豆</span>
            <span v-if="scope.row.prizeType == 3">实物</span>
            <span v-if="scope.row.prizeType == 4">店铺积分</span>
            <span v-if="scope.row.prizeType == 5">京豆E卡</span>
            <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
            <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
            <span v-if="scope.row.prizeType == 8">现金红包</span>
            <span v-if="scope.row.prizeType == 9">谢谢参与</span>
            <span v-if="scope.row.prizeType == 10">礼品卡</span>
            <span v-else-if="scope.row.prizeType == 12&&venderType">令牌</span>
              <span v-else-if="scope.row.prizeType == 12&&!venderType">专享价</span>
            <span v-else-if="scope.row.prizeType == 13">令牌</span>
            <span v-else-if="scope.row.prizeType == 14">实物（随单发）</span>
          </template>
        </el-table-column>
        <el-table-column prop="prizeName" label="奖品名称" width="210"></el-table-column>
        <el-table-column prop="compensationPrizeName" label="补发奖品名称" width="210"></el-table-column>
        <el-table-column label="随单发订单号" width="210">
          <template slot-scope="{ row }">
            <span>{{ row.orderId || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="中奖状态" width="130">
          <template slot-scope="{ row }">
            <span v-if="row.status == 0">-</span>
            <span v-if="row.status == -1"><jd-status :status="1">待领取</jd-status></span>
            <span v-if="row.status == 1"><jd-status :status="4">未中奖</jd-status></span>
            <span v-if="row.status == 2"><jd-status :status="0">已中奖</jd-status></span>
            <span v-if="row.status == 3"><jd-status :status="0">已发放</jd-status></span>
            <span v-if="row.status == 4"><jd-status :status="3">发放失败 
              <el-tooltip effect="dark" v-if="row.status == 4" :content="row.failReason" placement="top-start">
              <i
                style="color: #ccc"
                v-if="row.status == 4"
                class="el-icon-question"
              ></i>
            </el-tooltip></jd-status></span>
            <span v-if="row.status == 5"><jd-status :status="0">已发放</jd-status></span>
            <span v-if="row.status == 6"><jd-status :status="0">已发放</jd-status></span>
            <span v-if="row.status == 7"><jd-status :status="2">待发放</jd-status></span>
            <span v-if="row.status == 8"><jd-status :status="4">已失效</jd-status></span>
          </template>
        </el-table-column>
        <el-table-column label="参与活动订单" width="160">
          <template slot-scope="{ row }">
            <div v-if="row.joinOrders && row.joinOrders.length > 0">
              <div v-for="(order, index) in row.joinOrders" :key="index" style="margin-bottom: 5px;">
                <el-tooltip effect="light" placement="top-start">
                  <template slot="content">
                    <div class="order-info">
                      <div>订单号：{{ order.orderId || '-' }}</div>
                      <div>订单金额：{{ order.orderPayment ? order.orderPayment + '元' : '-' }}</div>
                      <div>订单状态：{{ order.orderStateRemark || '-' }}</div>
                    </div>
                  </template>
                  <span style="color: #3159ff; cursor: pointer;">{{ order.orderId || "-" }}</span>
                </el-tooltip>
              </div>
            </div>
            <div v-else>
              -
            </div>
          </template>
        </el-table-column>
        <el-table-column label="中奖订单" width="160">
          <template slot-scope="{ row }">
            <div v-if="row.winOrders && row.winOrders.length > 0">
              <div v-for="(order, index) in row.winOrders" :key="index" style="margin-bottom: 5px;">
                <el-tooltip effect="light" placement="top-start">
                  <template slot="content">
                    <div class="order-info">
                      <div>订单号：{{ order.orderId || '-' }}</div>
                      <div>订单金额：{{ order.orderPayment ? order.orderPayment + '元' : '-' }}</div>
                      <div>订单状态：{{ order.orderStateRemark || '-' }}</div>
                    </div>
                  </template>
                  <span style="color: #3159ff; cursor: pointer;">{{ order.orderId || "-" }}</span>
                </el-tooltip>
              </div>
            </div>
            <div v-else>
              -
            </div>
          </template>
        </el-table-column>
        <el-table-column label="领奖时间" width="160">
          <template slot-scope="{ row }">
            {{ row.joinTime || "-" }}
          </template>
        </el-table-column>
        <el-table-column label="是否满足确认收货天数" width="180">
          <template slot-scope="{ row }">
            {{ row.isPassOrderEnd==1?'已满足':row.isPassOrderEnd==0?'未满足': "-" }}
          </template>
        </el-table-column>
        <el-table-column label="是否满足活动结束天数" width="180">
          <template slot-scope="{ row }">
            {{ row.isPassActivityEnd==1?'已满足':row.isPassActivityEnd==0?'未满足': "-" }}
          </template>
        </el-table-column>
        <el-table-column
          label="发放时间"
          width="210"
        >
          <template slot-scope="{ row }">
            {{ row.grantTime || "-" }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="170"
        >
          <template slot-scope="{ row }">
            <jd-button
              type="blueText"
              v-if="row.status == 4"
              @click="handleMark(1, row,row.prizeType)"
              >标记发放</jd-button
            >
            <jd-button
              type="blueText"
              v-if="row.status == 6 || row.status == 5"
              @click="handleMark(1, row)"
              >取消发放</jd-button
            >
          </template>
        </el-table-column>
      </jd-table>
    </div>
      <!-- 生成人群 -->
      <crowdDialog v-if="isShowCrowdDialog" 
      :isShowCrowdDialog="isShowCrowdDialog" 
      :searchForm="formList" 
      :activityType="rowData.activityType"
      :source="3"
      :defaultValue="hasDefaultValue"
      :defaultValueText="defaultValueText"
      @close="crowdClose" 
    />

    <!-- 导出 -->
    <generate 
      :control="openRemarkDialog" 
      v-if="openRemarkDialog" 
      @transData="(val) => (openRemarkDialog = val)"
      @transData1="confirmExport"
    ></generate>
    <jd-dialog
      title="标记发放"
      width="420px"
      :visible.sync="isShowOrder"
      @close="closeOrder"
    >
      <el-form
        :model="orderFrom"
        label-width="86px"
        ref="orderFormRef"
        class="new-input-box"
      >
        <el-form-item label="随单发订单号：" prop="sendWithOrderId" required>
          <el-input
            placeholder=""
            v-model="orderFrom.sendWithOrderId"
            style="width: 250px"
            @keydown.native="clearInput"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <jd-button @click="closeOrder">取消</jd-button>
        <jd-button
          type="blue"
          @click="orderSubmit"
          >确定标记发放</jd-button
        >
      </template>
    </jd-dialog>
    <!-- 补发奖品 -->
    <reissueHdPrize v-if="isShowSendPrize" :valueRow="rowData" :searchCond="searchCond" :isShowSendPrize="isShowSendPrize" @close="isShowSendPrize = false" @createFn="getList()"></reissueHdPrize>
  </div>
</template>

<script>
import crowdDialog from "../crowd-Dialog.vue";
import { getUnlockRecord, exportPointActivityPrizeDetail } from "@/api/jhk/integralCenter/PointActivityAnalyticController2.js";
import { signIssuance, markingSendStatus,markSendWithOrder } from '@/api/jhk/integralCenter/PointActivityAnalyticController';
import {exportPrizeDetail } from "@/api/jhk/politely.js";
import prizeList from "../components/prize-preview.vue";
import statisticsData from "@/mixin/activity_statistics_new.js";
import reissueHdPrize from "./reissueHdPrize.vue"
export default {
  mixins: [statisticsData],
  components: {
    prizeList,
    crowdDialog,
    reissueHdPrize
  },
  props: {
    rowData: { // 活动数据
      type: Object,
      default: () => {}
    },
    currentShop: { // 当前选择店铺
      type: String,
      default: '',
    },
    sellerLinkList: {
      type: Array,
      default: () => []
    },
    levelList: { // 会员等级列表
      type: Array,
      default: () => []
    },
    levelMap: { // 会员等级映射表
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      searchCond: null,
      isShowSendPrize: false,
      allWinPeoples: 0,
      formSchema:[
        {
          label: "用户PIN：",
          prop: "pin",
          type: "Input",
          placeholder: "请输入用户pin, 精确查询",
        },
        {
          label: "用户昵称：",
          prop: "memberNick",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "会员等级：",
          prop: "memberLevel",
          type: "Select",
          placeholder: "请选择",
          value: "",
          options: [
            { label: "全部", value: "" },
          ]
        },
        {
          label: "领奖时间：",
          prop: "dateRange",
          type: "DateRange",
          dateType: "datetime",
          // startTime:this.getDateStr(-30) + " 00:00:00",
          // endTime:this.getDateStr(0) + " 23:59:59",
          startTime:'', //进来默认时间但没传值，所以测试叫我去掉默认值
          endTime:'',
          startKey: "startTime",
          endKey: "endTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          label: "奖品类型：",
          prop: "prizeType",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            { label: "优惠券", value: 1 },
            { label: "京豆", value: 2 },
            { label: "实物", value: 3 },
            { label: "店铺积分", value: 4 },
            { label: "京东E卡", value: 5 },
            { label: "爱奇艺会员", value: 6 },
            { label: "PLUS会员", value: 7 },
            { label: "现金红包", value: 8 },
            { label: "礼品卡", value: 10 },
            { label: "令牌", value: 13 },
            ...(this.venderType 
            ? [{ label: "令牌", value: 12 }]
            : [{ label: "专享价", value: 12 }]),
            { label: "实物（随单发）", value: 14 },
          ],
        },
        {
          label: "发放时间：",
          prop: "dateRange",
          type: "DateRange",
          dateType: "datetime",
          // startTime:this.getDateStr(-30) + " 00:00:00",
          // endTime:this.getDateStr(0) + " 23:59:59",
          startTime:'',
          endTime:'',
          startKey: "sendStartTime",
          endKey: "sendEndTime",
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
        },
        {
          label:"中奖状态：",
          prop: "status",
          placeholder: "请选择",
          type: "Select",
          value: "",
          options: [
            {
              label: '全部',
              value: '',
            },
            {
              label: '已中奖',
              value: 2
            },
            {
              label: '已发放',
              value: 3,
            },
            { label: "发放失败", value: 4 },
            { label: "已失效", value: 8 }
          ],
        },
        {
          label: "投放渠道：",
          prop: "sellerLinkId",
          type: "Select",
          value: "",
          options: []
        },
        {
          label: "奖品名称：",
          prop: "prizeName",
          type: "Input",
          placeholder: "请输入",
        },
        {
          label: "中奖次数：",
          startKey: "winNumMinLimit",
          endKey: "winNumMaxLimit",
          type: "InputDouble",
          startPlaceholder: "请输入",
          endPlaceholder: "请输入",
          inputType: "number",
          input: (val, item) => {
            if(item.winNumMinLimit&&item.winNumMaxLimit&&(Number(item.winNumMinLimit)>Number(item.winNumMaxLimit))){
              this.$message.error("前置数值不可大于后置数值")
              item.winNumMinLimit = ""
              return
            }
          }
        },
      ],
      formList: {
        size: 10,
        current: 1,
        total: 0,
        activityId: this.rowData.id,
      }, // 表单数据 
      awardTable: [], // 奖品列表
      tableLoading: false, // 表格加载
      multipleSelection: [], // 选择的数据
      searchInfo: {}, // 搜索条件
      isShowCrowdDialog: false, // 生成人群
      hasDefaultValue: false, // 是否有默认值
      defaultValueText: '', // 默认值文本
      openRemarkDialog: false, // 导出备注弹窗
      tabName: "",
      isShowOrder: false, // 是否显示订单查询弹窗
      orderFrom: {
        sendWithOrderId: '',
      },
      orderFormRules: {
        sendWithOrderId: [
          { required: true, message: "请输入随单发订单号", trigger: "blur" },
        ],
      }
    } 
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    }
  },
  watch: {
    sellerLinkList: {
      handler(newVal, oldVal) {
        if(newVal.length) {
          const list = newVal.map((item)=>{
            return {
              label: item.sellerLinkName,
              value: item.id
            }
          })
          this.formSchema.some((item)=>{
            if(item.prop=='sellerLinkId') {
              item.options = list
            }
          })
        }
      },
      deep: true,
    },
    levelList: {
      handler(newVal) {
        // 更新会员等级查询选项
        if(newVal && newVal.length) {
          const idx = this.formSchema.findIndex(item => item.prop === 'memberLevel');
          if (idx !== -1) {
            this.formSchema[idx].options = [ { label: "全部", value: ""},{label: "非会员", value: "0"},...newVal];
          }
        }
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    handleSendPrize() {
      this.isShowSendPrize = true
    },
    clearInput(e) {
      let key = e.key;
      if (key === "e" || key === "E" || key === "+" || key === "-") {
        e.returnValue = false;
        return false;
      }
      return true;
    },
    closeOrder() {
      this.orderFrom.sendWithOrderId = '';
      this.isShowOrder = false
    },
    orderSubmit() {
      this.$refs.orderFormRef.validate(async(valid) => {
        if (valid) {
          const res = await markSendWithOrder(this.orderFrom);
          if (res.code === 1) {
            this.$message.success('操作成功');
            this.closeOrder()
            this.formList.current = 1
            this.getList();
          } else {
            this.$message.error(res.msg || '操作失败');
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  handleSizeAwardAll(val) {
    console.log(val);
    this.formList.size = val.pageSize
    this.formList.current = val.pageNum
    this.getList();
  },
    /**
     * 限制表格行的选择，仅当状态为发放失败（4） 时允许选择
     * @param {Object} row 当前行的数据对象
     * @returns {boolean} 是否允许选择该行
     */
    limitSelect(row) {
      return row.status == 4&&row.prizeType!=14;
    },
    /**
     * 搜索
     * @param params 
     * @param type 
     */
    searchReward(params, type) {
      this.formList.current = 1;
      delete this.formList.total;
      this.formList = {
        ...this.formList,
        ...params,
      }
      this.formList.sellerLinkId = params.sellerLinkId ? params.sellerLinkId : "";
      if(type == 'reset') {
        this.searchInfo = {};
        this.formList.size = 10
        this.formList.current = 1
        this.getList();
        return;
      }
      this.searchInfo = params;

      this.getList();
    },
    async getList() {
      try {
        this.tableLoading = true;
        const params = {
          ...this.searchInfo,
          ...this.formList,
          activityId: this.rowData.id,
        }
        this.searchCond = params;
        const res = await getUnlockRecord(params);
        let { records=[], total=0 } = res.data;
        this.awardTable = records;
        this.allWinPeoples = res.data.message || 0;
        this.formList.total = Number(total);
      } catch (error) {
        
      } finally {
        this.tableLoading = false;
       }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSizeAward(val) {
      this.formList.size = val;
      this.getList(); 
    },
    handleCurrentAward(val) {
      this.formList.current = val;
      this.getList();
    },
    /**
     * 生成人群
     */
    addCrowd() {
      this.hasDefaultValue = true;
      this.defaultValueText = '满额有礼-领奖记录-'
      this.isShowCrowdDialog = true;
    },
    crowdClose() {
      this.isShowCrowdDialog = false; 
      // 关闭时重置
      if(this.hasDefaultValue){
        this.hasDefaultValue = false;
        this.defaultValueText = '';
      }
    },
    /**
     * 标记发放
     * @param row 当前行数据
     * @param type 类型 1 单个发放 2 批量发放
     */
    async handleMark(type = 1, row = {},prizeType=null) {
      try {
        let ids = [];
        if (type === 2) {
          if (!this.multipleSelection.length) {
            return this.$message.warning("请先勾选有效数据再操作");
          }
          ids = this.multipleSelection.map((item) => item.id);
        }

        this.tableLoading = true;

        let res;
        if (type === 2) {
          res = await markingSendStatus(2, ids);
        } else {
          if(prizeType==14) {
            this.isShowOrder = true;
            this.orderFrom.recordId = row.recordId || row.id;
          } else {
            res = await signIssuance({ id: row.recordId || row.id });
          }
        }

        if (res.code === 1) {
          this.$message.success('操作成功');
          this.getList();
        } else {
          this.$message.error(res.data.message);
        }
      } catch (error) {
        this.$message.error('操作失败');
      } finally {
        this.tableLoading = false;
      }
    },
    /**
     * 导出
     */
    exportFn() {
      this.openRemarkDialog = true;
    },
    /**
     * 确认导出
     * @param exportRemark 备注内容
     */
    confirmExport(exportRemark='') {
      let obj = this.$refs.inputFormRef.export_fun2();
      let params = {
        ...obj,
        activityId: this.rowData.id,
        current: 1,
        size: 9999999,
        exportRemark
      }
      this.tableLoading=true;
      exportPrizeDetail(params).then((res) => {
        this.tableLoading = false;
      });
    },
  }
}
</script>

<style lang="scss" scoped>
  .flex-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .mb16 {
    margin-bottom: 16px;
  }
  .award-title {
    font-weight: bold;
  }
  .y1,
  .y2,
  .y3,
  .y4 {
    display: inline-block;
    padding: 6px 10px;
    border-radius: 17px;
    margin-right: 5px;
  }
  .y1 {
    color: #5b5b5b;
    background-color: #f1f1f1;
  }
  .y2 {
    color: #02b1ff;
    background: #e6f7ff;
  }
  .y3 {
    color: #f56c6c;
    background-color: #fef0f0;
  }
  .y4 {
    color: #67c23a;
    background-color: #f0f9eb;
  }
  .order-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 8px;
  }
</style>